export default __webpack_public_path__ + "src/public/ph-letterbox-206x80.png";